import { select } from "redux-saga/effects";

import { writeToLocalStorage } from "common/utilities/localStorage";
import { getDismissedIncidents } from "domains/incidents/selectors";

export function* storeDismissedIncidentsSaga() {
  const dismissedIncidents: ReturnType<typeof getDismissedIncidents> = yield select(getDismissedIncidents);
  writeToLocalStorage("DISMISSED_INCIDENTS_STORAGE_KEY", dismissedIncidents);
}
